var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "example" },
    [
      _c(
        "b-card",
        [
          _c(
            "b-card-header",
            [_c("b-card-title", [_vm._v("Cost Analysis")])],
            1
          ),
          _c("apexcharts", {
            attrs: {
              height: "350",
              type: "bar",
              options: _vm.chartOptions,
              series: _vm.chartData,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }